export default "__VITE_ASSET__W_ShSAwp__"